// extracted by mini-css-extract-plugin
module.exports = {"userPic":"user_userPic__7Im-m","brandIcon":"user_brandIcon__2D9NI"};